var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aads-price-points',{attrs:{"enterprise-price":this.enterpriseMarkedUp,"small5-users-price":this.small5UsersMarkedUp,"small10-users-price":this.small10UsersMarkedUp,"small-unlimited-users-price":this.smallUnlimitedUsersMarkedUp}})}
var staticRenderFns = []

export { render, staticRenderFns }